import { createBrowserRouter, Navigate } from 'react-router';
import { UserGate } from '@/auth/UserGate';
import { Faq } from '@/pages/Faq';
import { DetailedNews } from '@/pages/DetailedNews';
import { Home } from '@/pages/Home';
import { Mail } from '@/pages/Mail';
import { StudentJoinOffers } from '@/pages/Offers';
import { Diary } from '@/pages/Diary';
import { Overview } from '@/pages/Overview';
import { Partners } from '@/pages/Partners';
import { Other } from '@/pages/Other';
import { OtherTheme } from '@/pages/Other/Theme';
import { SchoolLinks } from '@/pages/SchoolLinks';
import { ProfileSelection } from '@/pages/Profile';
import { SubscriptionIntro } from '@/pages/Subscription/Intro';
import { SubscriptionCheckout } from '@/pages/Subscription/Checkout';
import { SubscriptionPaymentOptions } from '@/pages/Subscription/PaymentOptions';
import { TermsAndConditions } from '@/pages/Terms';
import { BackNavigationGuard } from '@/router/BackNavigationGuard';
import { RouteError } from '@/router/RouteError';
import { SubscriptionGate } from '@/router/SubscriptionGate';
import {
  ROUTE_DETAILED_NEWS,
  ROUTE_DIARY,
  ROUTE_HOME,
  ROUTE_MAIL,
  ROUTE_OTHER,
  ROUTE_OTHER_THEME,
  ROUTE_OVERVIEW,
  ROUTE_PARTNERS,
  ROUTE_PROFILE_FAQ,
  ROUTE_PROFILE_SELECTION,
  ROUTE_ROOT,
  ROUTE_SCHOOL_LINKS,
  ROUTE_STUDENT_JOIN_OFFERS,
  ROUTE_SUBSCRIPTION,
  ROUTE_SUBSCRIPTION_CHECKOUT,
  ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS,
  ROUTE_SUPPORT,
  ROUTE_TERMS_AND_CONDITIONS,
} from '@/router/routes';

export const router = createBrowserRouter([
  {
    Component: BackNavigationGuard,
    ErrorBoundary: RouteError,
    children: [
      {
        Component: UserGate,
        ErrorBoundary: RouteError,
        children: [
          { path: ROUTE_ROOT, element: <Navigate to={ROUTE_HOME} replace /> },
          { path: ROUTE_TERMS_AND_CONDITIONS, Component: TermsAndConditions },
          { path: ROUTE_STUDENT_JOIN_OFFERS, Component: StudentJoinOffers },
          { path: ROUTE_PROFILE_SELECTION, Component: ProfileSelection },
          { path: ROUTE_PROFILE_FAQ, element: <Faq isStandalone /> },
          { path: ROUTE_HOME, Component: Home },
          { path: ROUTE_DETAILED_NEWS, Component: DetailedNews },
          { path: ROUTE_DIARY, Component: Diary },
          { path: ROUTE_OVERVIEW, Component: Overview },
          { path: ROUTE_MAIL, Component: Mail },
          { path: ROUTE_PARTNERS, Component: Partners },
          { path: ROUTE_SCHOOL_LINKS, Component: SchoolLinks },
          {
            Component: SubscriptionGate,
            children: [
              { path: ROUTE_SUBSCRIPTION, Component: SubscriptionIntro },
              {
                path: ROUTE_SUBSCRIPTION_PAYMENT_OPTIONS,
                Component: SubscriptionPaymentOptions,
              },
              {
                path: ROUTE_SUBSCRIPTION_CHECKOUT,
                Component: SubscriptionCheckout,
              },
            ],
          },
          { path: ROUTE_SUPPORT, Component: Faq },
          { path: ROUTE_OTHER, Component: Other },
          { path: ROUTE_OTHER_THEME, Component: OtherTheme },
        ],
      },
    ],
  },
]);
